var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4142 0.586C12.0391 0.211 11.5304 0 11 0H2C1.4696 0 0.9609 0.211 0.5858 0.586C0.2107 0.961 0 1.47 0 2V18C0 18.53 0.2107 19.039 0.5858 19.414C0.9609 19.789 1.4696 20 2 20H11C11.5304 20 12.0391 19.789 12.4142 19.414C12.7893 19.039 13 18.53 13 18V16H11V18H2V2H11V4H13V2C13 1.47 12.7893 0.961 12.4142 0.586ZM13 12V15L18 10L13 5V8H6V12H13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4142 0.586C12.0391 0.211 11.5304 0 11 0H2C1.4696 0 0.9609 0.211 0.5858 0.586C0.2107 0.961 0 1.47 0 2V18C0 18.53 0.2107 19.039 0.5858 19.414C0.9609 19.789 1.4696 20 2 20H11C11.5304 20 12.0391 19.789 12.4142 19.414C12.7893 19.039 13 18.53 13 18V16H11V18H2V2H11V4H13V2C13 1.47 12.7893 0.961 12.4142 0.586ZM13 12V15L18 10L13 5V8H6V12H13Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSair);
export default __webpack_public_path__ + "static/media/sair.ea5a66cb660a3503d5878250a4689fd6.svg";
export { ForwardRef as ReactComponent };